import { action, makeObservable, observable } from 'mobx';

import { InsightsAccordionKeys } from '@/layouts/OrganizationLayout/NoteContent/insights/InsightsLists/types';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';

export class InsightsAccordionItemsStore implements ILocalStore {
  keys: InsightsAccordionKeys[];

  constructor(defaultKeys: InsightsAccordionKeys[]) {
    this.keys = defaultKeys;

    makeObservable(this, {
      keys: observable.ref,
      setKeys: action.bound,
    });
  }

  setKeys(keys: InsightsAccordionKeys[]) {
    this.keys = keys;
  }

  destroy() {
    // no to do
  }
}
